import React, { useState, useRef, useEffect } from "react";
import { Button, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import styled, { css } from "styled-components";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewer = ({ file }) => {
  const [numOfPages, setNumOfPages] = useState(null);
  const [scale, setScale] = useState(1.5);

  function handleDocumentLoadSuccess({ numPages }) {
    setNumOfPages(numPages);
  }

  function handlePageLoadSuccess() {
    let pageElements = Array.from(
      document.getElementsByClassName("pdfPageNumber")
    );
    pageElements.forEach((element) => {
      element.classList.add("pdfPageColor");
    });
  }

  return (
    <StyledDocumentDiv>
      <Document file={file} onLoadSuccess={handleDocumentLoadSuccess}>
        {[...Array(numOfPages)].map((_, page) => (
          <div key={page + 1}>
            <Page
              scale={scale}
              pageNumber={page + 1}
              loading=""
              onLoadSuccess={handlePageLoadSuccess}
            />
            <StyledPageNumberDiv className="pdfPageNumber">
              Page {page + 1} of {numOfPages}
            </StyledPageNumberDiv>
          </div>
        ))}
        <StyledIconsDiv>
          <StyledIconButton
            disabled={scale <= 0.25}
            onClick={() => {
              setScale(scale - 0.25);
            }}
          >
            <StyledRemoveIcon scale={scale} />
          </StyledIconButton>
          <StyledIconButton
            onClick={() => {
              scale === 1.5 ? setScale(2.0) : setScale(1.5);
            }}
          >
            {scale <= 1.5 ? <StyledZoomInIcon /> : <StyledZoomOutIcon />}
          </StyledIconButton>
          <StyledIconButton
            disabled={scale >= 3.5}
            onClick={() => {
              setScale(scale + 0.25);
            }}
          >
            <StyledAddIcon scale={scale} />
          </StyledIconButton>
        </StyledIconsDiv>
      </Document>
    </StyledDocumentDiv>
  );
};

const StyledDocumentDiv = styled.div`
  max-width: 100%;
  overflow: auto;
  height: inherit;
  align-self: end;
`;

const StyledPageNumberDiv = styled.div`
  color: transparent;
  text-align: center;
`;

const StyledIconsDiv = styled.div`
  display: inline-block;
  padding: 2px;
  background-color: rgba(0, 0, 0, 0.75);
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10%;
  border-radius: 3px;
`;

const StyledIconButton = styled(IconButton)`
  && {
    padding: 10px;
    border-radius: 0px;
    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
`;

const StyledRemoveIcon = styled(RemoveIcon)`
  && {
    ${(props) =>
      props.scale <= 0.25
        ? css`
            color: #808080;
          `
        : css`
            color: #fff;
          `};
  }
`;

const StyledAddIcon = styled(AddIcon)`
  && {
    ${(props) =>
      props.scale >= 3.5
        ? css`
            color: #808080;
          `
        : css`
            color: #fff;
          `};
  }
`;

const StyledZoomInIcon = styled(ZoomInIcon)`
  && {
    color: #fff;
  }
`;

const StyledZoomOutIcon = styled(ZoomOutIcon)`
  && {
    color: #fff;
  }
`;
export default PdfViewer;
